(() => {
  const body = document.body;
  const money = (cents) => {
    const value = (Number(cents || 0) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    return value;
  };

  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobilePanel = document.querySelector('[data-mobile-panel]');
  if (menuButton && mobilePanel) {
    menuButton.addEventListener('click', () => {
      const open = mobilePanel.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
  }

  const searchButton = document.querySelector('[data-search-toggle]');
  const mobileSearch = document.querySelector('[data-mobile-search]');
  if (searchButton && mobileSearch) {
    searchButton.addEventListener('click', () => {
      const open = mobileSearch.classList.toggle('is-open');
      searchButton.setAttribute('aria-expanded', String(open));
      if (open) mobileSearch.querySelector('input')?.focus();
    });
  }

  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  const drawerLines = document.querySelector('[data-drawer-lines]');
  const drawerTotal = document.querySelector('[data-drawer-total]');

  const setDrawer = (open) => {
    if (!drawer || !overlay) return;
    drawer.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('is-locked', open);
    if (open) drawer.querySelector('[data-drawer-close]')?.focus();
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cart-open]');
    const close = event.target.closest('[data-drawer-close], [data-drawer-overlay]');
    if (open) { event.preventDefault(); setDrawer(true); }
    if (close) { event.preventDefault(); setDrawer(false); }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setDrawer(false); });

  const updateCounts = (count) => document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = count; });

  const renderDrawer = (cart) => {
    updateCounts(cart.item_count);
    if (!drawerLines || !drawerTotal) return;
    drawerTotal.textContent = money(cart.total_price);
    if (!cart.items.length) {
      drawerLines.innerHTML = '<div class="drawer-empty"><h3>SEU CARRINHO ESTÁ VAZIO</h3><p>Os próximos favoritos estão a um clique.</p></div>';
      return;
    }
    drawerLines.innerHTML = cart.items.map((item) => `
      <article class="drawer-line">
        ${item.image ? `<img src="${item.image}" alt="" width="180" height="224">` : ''}
        <div><h3><a href="${item.url}">${item.product_title}</a></h3>
        ${item.variant_title ? `<p>${item.variant_title}</p>` : ''}<strong>${money(item.final_line_price)}</strong>
        <div class="quantity"><button type="button" data-cart-change data-key="${item.key}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Diminuir quantidade">−</button><span>${item.quantity}</span><button type="button" data-cart-change data-key="${item.key}" data-quantity="${item.quantity + 1}" aria-label="Aumentar quantidade">+</button><button type="button" data-cart-change data-key="${item.key}" data-quantity="0" aria-label="Remover ${item.product_title}">×</button></div></div>
      </article>`).join('');
  };

  const refreshCart = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Não foi possível atualizar o carrinho.');
    const cart = await response.json();
    renderDrawer(cart);
    return cart;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-change]');
    if (!button) return;
    button.disabled = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: button.dataset.key, quantity: Number(button.dataset.quantity) }) });
      if (!response.ok) throw new Error('Não foi possível alterar o item.');
      renderDrawer(await response.json());
    } catch (error) { window.alert(error.message); }
    finally { button.disabled = false; }
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const original = submit.textContent;
      submit.disabled = true;
      submit.textContent = 'ADICIONANDO…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) { const data = await response.json(); throw new Error(data.description || 'Não foi possível adicionar o produto.'); }
        await refreshCart();
        setDrawer(true);
      } catch (error) { window.alert(error.message); }
      finally { submit.disabled = false; submit.textContent = original; }
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const select = root.querySelector('[data-variant-select]');
    const idInput = root.querySelector('[name="id"]');
    const price = root.querySelector('[data-product-price]');
    const pixPrice = root.querySelector('[data-pix-price]');
    const add = root.querySelector('[data-add-button]');
    const data = root.querySelector('[data-variants-json]');
    if (!select || !idInput || !data) return;
    const variants = JSON.parse(data.textContent);
    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === select.value);
      if (!variant) return;
      idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (pixPrice) pixPrice.textContent = money(Math.round(variant.price * 0.95));
      if (add) { add.disabled = !variant.available; add.textContent = variant.available ? 'ADICIONAR AO CARRINHO' : 'INDISPONÍVEL'; }
      if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    });
  });
  const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  document.querySelectorAll('[data-product-showcase]').forEach((showcase) => {
    const cards = [...showcase.querySelectorAll('[data-filter-card]')];
    const category = showcase.querySelector('[data-filter-category]');
    const price = showcase.querySelector('[data-filter-price]');
    const count = showcase.querySelector('[data-visible-count]');
    const noResults = showcase.querySelector('[data-no-results]');
    let size = '';
    let color = '';
    const applyFilters = () => {
      const categoryValue = normalize(category?.value);
      const priceRange = price?.value ? price.value.split('-').map(Number) : null;
      let visible = 0;
      cards.forEach((card) => {
        const text = normalize(card.dataset.filterText);
        const cardPrice = Number(card.dataset.filterPriceValue || 0);
        const show = (!categoryValue || text.includes(categoryValue)) && (!size || text.includes(normalize(size))) && (!color || text.includes(normalize(color))) && (!priceRange || (cardPrice >= priceRange[0] && cardPrice <= priceRange[1]));
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (count) count.textContent = String(visible).padStart(2, '0');
      if (noResults) noResults.hidden = visible !== 0;
    };
    category?.addEventListener('change', applyFilters);
    price?.addEventListener('change', applyFilters);
    showcase.addEventListener('click', (event) => {
      const sizeButton = event.target.closest('[data-filter-size]');
      const colorButton = event.target.closest('[data-filter-color]');
      const favorite = event.target.closest('[data-favorite]');
      if (sizeButton) { size = size === sizeButton.dataset.filterSize ? '' : sizeButton.dataset.filterSize; showcase.querySelectorAll('[data-filter-size]').forEach((button) => button.classList.toggle('is-active', button === sizeButton && Boolean(size))); applyFilters(); }
      if (colorButton) { color = color === colorButton.dataset.filterColor ? '' : colorButton.dataset.filterColor; showcase.querySelectorAll('[data-filter-color]').forEach((button) => button.classList.toggle('is-active', button === colorButton && Boolean(color))); applyFilters(); }
      if (favorite) { favorite.classList.toggle('is-active'); favorite.textContent = favorite.classList.contains('is-active') ? '♥' : '♡'; }
      if (event.target.closest('[data-filter-clear]')) { size = ''; color = ''; if (category) category.value = ''; if (price) price.value = ''; showcase.querySelectorAll('.is-active').forEach((node) => node.classList.remove('is-active')); applyFilters(); }
    });
    applyFilters();
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const triggers = [...gallery.querySelectorAll('[data-lightbox-trigger]')];
    const lightbox = gallery.parentElement.querySelector('[data-product-lightbox]');
    if (!triggers.length || !lightbox) return;
    const image = lightbox.querySelector('[data-lightbox-image]');
    const caption = lightbox.querySelector('[data-lightbox-caption]');
    const close = lightbox.querySelector('[data-lightbox-close]');
    const prev = lightbox.querySelector('[data-lightbox-prev]');
    const next = lightbox.querySelector('[data-lightbox-next]');
    let index = 0;
    let lastTrigger = null;
    const setImage = (nextIndex) => {
      index = (nextIndex + triggers.length) % triggers.length;
      const trigger = triggers[index];
      const source = trigger.querySelector('img');
      if (!source || !image) return;
      image.src = source.currentSrc || source.src;
      image.alt = source.alt || '';
      if (caption) caption.textContent = `${index + 1} / ${triggers.length}`;
    };
    const setOpen = (open) => {
      lightbox.hidden = !open;
      lightbox.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('is-lightbox-locked', open);
      if (open) { setImage(index); close?.focus(); } else { lastTrigger?.focus(); }
    };
    triggers.forEach((trigger) => trigger.addEventListener('click', () => { lastTrigger = trigger; index = Number(trigger.dataset.mediaIndex || 0); setOpen(true); }));
    close?.addEventListener('click', () => setOpen(false));
    prev?.addEventListener('click', () => setImage(index - 1));
    next?.addEventListener('click', () => setImage(index + 1));
    lightbox.addEventListener('click', (event) => { if (event.target === lightbox) setOpen(false); });
    document.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') setOpen(false);
      if (event.key === 'ArrowLeft') setImage(index - 1);
      if (event.key === 'ArrowRight') setImage(index + 1);
    });
  });
  const initTrendingCarousels = (scope = document) => {
    scope.querySelectorAll('[data-trending-carousel]').forEach((carousel) => {
      if (carousel.dataset.trendingReady === 'true') return;
      carousel.dataset.trendingReady = 'true';
      const viewport = carousel.querySelector('[data-trending-viewport]');
      const pages = [...carousel.querySelectorAll('[data-trending-page]')];
      const dots = [...carousel.querySelectorAll('[data-trending-dot]')];
      const previous = carousel.querySelector('[data-trending-prev]');
      const next = carousel.querySelector('[data-trending-next]');
      if (!viewport || pages.length < 2) return;
      const currentPage = () => pages.reduce((closest, page, index) =>
        Math.abs(page.offsetLeft - viewport.scrollLeft) < Math.abs(pages[closest].offsetLeft - viewport.scrollLeft) ? index : closest, 0);
      const update = () => {
        const current = currentPage();
        dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
        if (previous) previous.disabled = current === 0;
        if (next) next.disabled = current === pages.length - 1;
      };
      const moveTo = (index) => {
        const target = pages[Math.max(0, Math.min(index, pages.length - 1))];
        viewport.scrollTo({ left: target.offsetLeft - pages[0].offsetLeft, behavior: 'smooth' });
      };
      previous?.addEventListener('click', () => moveTo(currentPage() - 1));
      next?.addEventListener('click', () => moveTo(currentPage() + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => moveTo(index)));
      viewport.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  };
  initTrendingCarousels();
  document.addEventListener('shopify:section:load', (event) => initTrendingCarousels(event.target));
})();
